const SlimBanner = () => {
    return (
        <div className="slim-banner-outer">
            <div className="slim-banner-inner">
                <div>Buying for yourself or giving a gift? Need help deciding? <a href="/link-goes-nowhere">Connect with our experts today »</a></div>
            </div>
        </div>
    )
}

export default SlimBanner
